import { useEffect } from "react";
import { pullListSessions } from "@store/sessions/actions";
import { useDispatch, useSelector } from "react-redux";
import { selectIsAuthenticated } from "@store/userData/selectors";

const useSessionsList = () => {
  const TICKER_INTERVAL_MS = 30000;
  const isAuthenticated = useSelector(selectIsAuthenticated);

  const dispatch = useDispatch();

  useEffect(() => {
    if (!isAuthenticated) return;

    dispatch(pullListSessions());
    const ticker = setInterval(() => {
      dispatch(pullListSessions());
    }, TICKER_INTERVAL_MS);
    return () => {
      clearInterval(ticker);
    };
  }, [dispatch, isAuthenticated]);
};

export default useSessionsList;
